import { FeatureKey } from '@/graphql/schema'

export const AUTOMATIONS_FEATURE_KEY = FeatureKey.Automations.toLowerCase()
export const COMMUNICATIONS_FEATURE_KEY =
  FeatureKey.Communications.toLowerCase()

interface FeatureDecisionLike {
  enabled: boolean
  key: string
}

export function isFeatureDecisionEnabled(
  decisions: Array<FeatureDecisionLike> | null | undefined,
  featureKey: string,
): boolean {
  return (
    decisions?.some(
      (decision) => decision.key === featureKey && decision.enabled,
    ) ?? false
  )
}

export function isAutomationsFeatureDecisionEnabled(
  decisions: Array<FeatureDecisionLike> | null | undefined,
): boolean {
  return isFeatureDecisionEnabled(decisions, AUTOMATIONS_FEATURE_KEY)
}

export function isCommunicationsFeatureDecisionEnabled(
  decisions: Array<FeatureDecisionLike> | null | undefined,
): boolean {
  return isFeatureDecisionEnabled(decisions, COMMUNICATIONS_FEATURE_KEY)
}
